
import type { SVGProps } from 'react';
const SvgBlog = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#blog_svg__a)">
      <path
        fill="#263E6A"
        fillRule="evenodd"
        d="M7.758 9.16h6.22V5.73h-6.22zM18.65 5.288l.06.001a1.05 1.05 0 0 1 .968 1.128l-1.123 14.217a1.051 1.051 0 0 1-1.133.964l-9.988-.78-1.1-.087a1.053 1.053 0 0 1-.968-1.127.54.54 0 0 1 .577-.49c.296.023.517.28.494.574l1.082.064 9.987.78 1.1-14.2a.52.52 0 0 1-.483-.563c.023-.294.285-.5.587-.48zm-2.932 9.171-2.489 2.475v-2.475zm-1.203-9.798c.297 0 .537.238.537.534v4.5c0 .294-.24.533-.537.533H7.221a.536.536 0 0 1-.537-.534v-4.5c0-.295.24-.533.537-.533zm-9.14-1.193h10.019l1.083-.02v9.944l-.003-.001H12.69a.536.536 0 0 0-.537.534v3.762l.001.004-6.76.018zM16.497 2.4H5.374c-.581 0-1.054.47-1.054 1.048v14.261c0 .579.473 1.049 1.054 1.049h7.317a.54.54 0 0 0 .38-.157l4.322-4.298a.53.53 0 0 0 .157-.378V3.448c0-.578-.472-1.048-1.053-1.048"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="blog_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBlog;
